'use strict';

var _ = require('lodash');
var tooltipTemplate = _.template(require('../templates/chart-example-tooltip-template.html'));
var ChartExampleController = function ChartExampleController($scope, $filter, dataProviderService, chartFormatter) {
  var defaultSelectionSize = 30;
  var rmNumberFormat = $filter('rmNumberFormat');
  var rmMomentFormat = $filter('rmMomentFormat');
  $scope.metricLabels = ['Bookings', 'Revenue', 'Yield', 'Demand'];
  $scope.selectedMetric = $scope.metricLabels[0];
  $scope.initChart = function () {
    $scope.changeMetricHandler($scope.selectedMetric);
  };
  $scope.changeMetricHandler = function (metric) {
    $scope.selectedMetric = metric;
    var chartData = dataProviderService.getData($scope.selectedMetric);
    var data = chartData.data;
    $scope.legend = chartData.legend;
    $scope.renderChart(data, defaultSelectionSize);
    if (data !== undefined) {
      $scope.setInitialSelection([0, data.length]);
    }
  };
  $scope.chartFormatters = {
    xAxisTickFormatter: function xAxisTickFormatter(d, i) {
      return d && d.format(i % 4 === 0 ? 'D|MMM' : 'D');
    },
    yAxisTickFormatter: chartFormatter.humanReadable,
    tooltipFormatter: function tooltipFormatter(d) {
      return tooltipTemplate({
        m1: rmNumberFormat(d.m1, 'NUMBER'),
        m2: rmNumberFormat(d.m2, 'NUMBER'),
        m1Label: $scope.selectedMetric + ' Current',
        m2Label: $scope.selectedMetric + ' Expected',
        date: rmMomentFormat(d.d1, 'DATE_USER_SETTINGS')
      });
    }
  };
};
ChartExampleController.$inject = ['$scope', '$filter', 'ChartExampleDataProviderService', 'FormatterService'];
module.exports = ChartExampleController;